import React from 'react'
import RotatableBox from './RotatableBox'
import {degToRad} from './utils'
import './BarcodeRRD.scss'

const BarcodeRRD = props => {
  const refBox = React.useRef(null)
  const [style, setStyle] = React.useState({
    color: 'grey',
    transform: `rotateZ(${props.angleDeg}deg)`,
    width: props.width,
    height: props.height,
    top: props.y,
    left: props.x,
  })

  const handleRotateEnd = angle => {
    refBox.current.style.transform = `rotateZ(${angle.degrees}deg)`
    props.onRotateEnd(angle)
  }

  const handleResizeEnd = ({offsetX, offsetY, width, height}) => {
    props.onResizeEnd({offsetX, offsetY, width, height})
  }
  const handleMoveEnd = ({x, y}) => {
    props.onMoveEnd({x, y})
  }

  React.useEffect(() => {
    setStyle({
      color: 'grey',
      transform: `rotateZ(${props.angleDeg}deg)`,
      width: props.width,
      height: props.height,
      top: props.y,
      left: props.x,
    })
  }, [setStyle, props])

  return (
    <div
      ref={refBox}
      draggable={false}
      style={{...style, border: props.edit ? 'dashed thin black' : 'none', position: 'absolute'}}
      className="edit-box"
      onClick={props.onClick}
    >
      <RotatableBox
        angle={{degrees: props.angleDeg, radians: degToRad(props.angleDeg)}}
        dim={{width: props.width, height: props.height}}
        pos={{
          top: props.y,
          left: props.x,
        }}
        lockAspectRatio={props.lockAspectRatio}
        onRotateEnd={handleRotateEnd}
        onResizeEnd={handleResizeEnd}
        onMoveEnd={handleMoveEnd}
        onClickDelete={props.onClickDelete}
        showControls={props.edit}
      >
        {props.children}
      </RotatableBox>
    </div>
  )
}

/// component

export default BarcodeRRD
